// extracted by mini-css-extract-plugin
export default {"zoomControls":"P_-z","zoomControlButton":"Q_-z","zoomBanner":"R_-z","bannerButton":"S_-z","imageButton":"T_-z","zoom":"U_-z","zoomContent":"V_-z"};